import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { FORM_KEYS } from "../constants";
import * as yup from "yup";

const schema = yup.object({
  [FORM_KEYS.ABBREV]: yup.string(),
  [FORM_KEYS.ANNOUNCEMENT]: yup.string(),
  [FORM_KEYS.CNAME]: yup.string(),
  [FORM_KEYS.BACKGROUND_COLOR]: yup.string().default("#FFF"),
  [FORM_KEYS.BACKGROUND_IMAGE]: yup.mixed(),
  [FORM_KEYS.DARK_MODE]: yup.boolean(),
  [FORM_KEYS.IS_PUBLIC_FUNKO]: yup.boolean().default(false),
  [FORM_KEYS.IS_PUBLIC_LOUNGEFLY]: yup.boolean().default(false),
});

/**
 * @desc Hook for validating order form.
 */
export const useConventionForm = (defaultValues = {}) => {
  return useForm({
    resolver: yupResolver(schema),
    mode: "all",
    defaultValues,
  });
};
